module.exports = __webpack_public_path__ + "img/social-sneaker-drop.15194318.jpg";